import { QueryOptions } from 'react-query';
import { fetchAllWithPaginationToken } from '../../utils/fetchAll';
import {
  getOrgPermissions,
  PermissionRole,
  PermissionUserType,
} from './org-permissions.api';
import { OrgPermissionsResponse } from './org-permissions.schema';

export const ORG_PERMISSIONS_QUERY_KEY_PREFIX = 'org-permissions';

export const getAllOrgPermissionsQuery = (
  orgId: number,
  filters?: {
    userType?: PermissionUserType;
    roles?: Array<PermissionRole>;
    userIds?: Array<string>;
  },
): QueryOptions<OrgPermissionsResponse['data']> => ({
  queryKey: [ORG_PERMISSIONS_QUERY_KEY_PREFIX, { orgId, filters }],
  queryFn: ({ signal }) =>
    fetchAllWithPaginationToken(
      token =>
        getOrgPermissions(orgId, filters, token, {
          limit: 999,
        }),
      { abortSignal: signal },
    ),
});
